module.exports = __webpack_public_path__ + "img/growing-heart.4422ac80.png";